/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateVolunteerRequest
 */
export interface CreateVolunteerRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateVolunteerRequest
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVolunteerRequest
     */
    salutation: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVolunteerRequest
     */
    title: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVolunteerRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVolunteerRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVolunteerRequest
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVolunteerRequest
     */
    houseNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVolunteerRequest
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVolunteerRequest
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVolunteerRequest
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVolunteerRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVolunteerRequest
     */
    phone: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateVolunteerRequest
     */
    remarks: string | null;
}

/**
 * Check if a given object implements the CreateVolunteerRequest interface.
 */
export function instanceOfCreateVolunteerRequest(value: object): value is CreateVolunteerRequest {
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('salutation' in value) || value['salutation'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('houseNumber' in value) || value['houseNumber'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    return true;
}

export function CreateVolunteerRequestFromJSON(json: any): CreateVolunteerRequest {
    return CreateVolunteerRequestFromJSONTyped(json, false);
}

export function CreateVolunteerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateVolunteerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'],
        'salutation': json['salutation'],
        'title': json['title'],
        'lastName': json['lastName'],
        'firstName': json['firstName'],
        'street': json['street'],
        'houseNumber': json['houseNumber'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'country': json['country'],
        'email': json['email'],
        'phone': json['phone'],
        'remarks': json['remarks'],
    };
}

export function CreateVolunteerRequestToJSON(json: any): CreateVolunteerRequest {
    return CreateVolunteerRequestToJSONTyped(json, false);
}

export function CreateVolunteerRequestToJSONTyped(value?: CreateVolunteerRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'salutation': value['salutation'],
        'title': value['title'],
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'street': value['street'],
        'houseNumber': value['houseNumber'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
        'email': value['email'],
        'phone': value['phone'],
        'remarks': value['remarks'],
    };
}

